import { addStyles, removeStyles } from '~/utils/EmbeddingFeed/ConfirmMessage/confirmMessageStyles';
import { constants } from '~/utils/EmbeddingFeed/ConfirmMessage/constants';
import { hashGenerator } from '~/utils/hashGenerator';

type UserSelection = (result: boolean) => void;

/**
 * Отображает диалоговое окно с двумя кнопками
 *
 * messageElement - html-элемент окна
 * messageText - текст сообщения
 * userSelection - функция обратного вызова, вызывается при нажатии кнопок
 * hash - хеш для исключения пересечений в названии классов и идентификаторов
 */
export class ConfirmMessage {
  messageElement: HTMLElement = null;
  messageText: string;
  userSelection: UserSelection;
  hash: string;

  constructor(
    userSelection: UserSelection,
    messageText: string = 'Место расположения ленты выбрано'
  ) {
    this.userSelection = userSelection;
    this.messageText = messageText;
    this.hash = hashGenerator(6);
  }

  /**
   * Создает текстовое представление html-элемента диалогового окна
   * @returns string
   */
  compileConfirmMessage = (): string => {
    const hash = this.hash;
    addStyles(hash);

    return `
      <div id="${constants.ID_CONFIRM_MESSAGE_ELEMENT}${hash}" class="message-parent-element__${hash}">
        <div class="message-text__${hash}">
          ${this.messageText}
        </div>
        <div class="button-selection-wrapper__${hash}">
          <div id="${constants.ID_CONFIRM_MESSAGE_POSITIVE_BUTTON}${hash}" class="buttons-confirm-message__${hash}">
            <div class="buttons-confirm-message-icon__${hash}">
              <svg width="21" height="20" margin="0 6px 0 0" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10.5" cy="10" r="10" fill="white"/>
                <path d="M7.5 10.4L9.62912 12L13.4615 8" stroke="#00BD7E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            Применить
          </div>
          <div id="${constants.ID_CONFIRM_MESSAGE_NEGATIVE_BUTTON}${hash}" class="buttons-confirm-message__${hash} __self-color__${hash}">
            <div class="buttons-confirm-message-icon__${hash}">
              <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.14576 2.35156L1.44276 10.0551C1.40401 10.094 1.37602 10.1431 1.3627 10.1958L0.508893 13.6228C0.483354 13.726 0.513668 13.8357 0.588955 13.9109C0.645919 13.9679 0.723538 13.9994 0.802933 13.9994C0.827251 13.9994 0.852125 13.9964 0.876332 13.9903L4.30332 13.1364C4.35673 13.1231 4.40526 13.0952 4.44401 13.0565L12.1477 5.35348L9.14576 2.35156Z" fill="white"/>
                <path d="M14.0561 1.30075L13.1986 0.44328C12.6255 -0.129809 11.6267 -0.129253 11.0543 0.44328L10.0039 1.49363L13.0057 4.49543L14.0561 3.44508C14.3423 3.15893 14.5 2.77805 14.5 2.37297C14.5 1.96789 14.3423 1.58702 14.0561 1.30075Z" fill="white"/>
              </svg>
            </div>
            Изменить
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Обрабатывает нажатие по кнопкам
   * @param status - boolean
   */
  sendUserSelection = (status: boolean) => {
    this.removeConfirmMessage();
    this.userSelection(status);
  }

  sendPositiveSelection = () => this.sendUserSelection(true);
  sendNegativeSelection = () => this.sendUserSelection(false);

  /**
   * Запускает или останавливает слушатели необходимые для работы окна
   * в зависимости от флага start
   * @param start - boolean
   */
  enginButtonsEventListener = (start: boolean) => {
    const positiveButton = document.getElementById(
      `${constants.ID_CONFIRM_MESSAGE_POSITIVE_BUTTON}${this.hash}`
    );
    const negativeButton = document.getElementById(
      `${constants.ID_CONFIRM_MESSAGE_NEGATIVE_BUTTON}${this.hash}`
    );
    if (start) {
      positiveButton.addEventListener('touchstart', this.sendPositiveSelection);
      positiveButton.addEventListener('click', this.sendPositiveSelection);
      negativeButton.addEventListener('touchstart', this.sendNegativeSelection);
      negativeButton.addEventListener('click', this.sendNegativeSelection);
    } else {
      positiveButton.removeEventListener(
        'touchstart',
        this.sendPositiveSelection
      );
      positiveButton.removeEventListener('click', this.sendPositiveSelection);
      negativeButton.removeEventListener(
        'touchstart',
        this.sendNegativeSelection
      );
      negativeButton.removeEventListener('click', this.sendNegativeSelection);
    }
  }

  /**
   * Отображает диалоговое окно
   */
  showConfirmMessage = () => {
    document.body.insertAdjacentHTML('beforeend', this.compileConfirmMessage());
    this.messageElement = document.getElementById(
      constants.ID_CONFIRM_MESSAGE_ELEMENT
    );
    this.enginButtonsEventListener(true);
  }

  /**
   * Удаляет диалоговое окно
   */
  removeConfirmMessage = () => {
    this.enginButtonsEventListener(false);
    if (this.messageElement) this.messageElement.remove();
    removeStyles(this.hash);
    document
    .getElementById(
      `${constants.ID_CONFIRM_MESSAGE_ELEMENT}${this.hash}`
    )
    .remove();
  }
}
